
























import axios from "axios";
import { egypt, headers, servicesURL, Vue } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
var locationMap;
var userLocationMarker;
export default Vue.component("pin-location-map", {
  data() {
    return {
      staticContent,
      pinningError: false,
      loadingDetectLocation: false,
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    pinningOpen() {
      return this.$parent.pinningOpen;
    },
    selectedTrip() {
      return this.$root.selectedTrip;
    },
  },
  methods: {
    initialize() {
      var mapOptions = {
        zoom: 11,
      };
      locationMap = new google.maps.Map(
        document.getElementById("pinLocationMap"),
        mapOptions
      );

      // Try HTML5 geolocation
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) =>{
            this.setMapMarker(
              position.coords.latitude,
              position.coords.longitude
            ); this.pinningError=false;
            },
          this.handleNoGeolocation()
        );
      } else {
        // Browser doesn't support Geolocation
        this.handleNoGeolocation();
      }
    },
    triggerDetectLocation() {
      if (navigator.geolocation) {
        this.loadingDetectLocation = true;
        navigator.geolocation.getCurrentPosition(
          (position) => {
            
            this.setMapMarker(
              position.coords.latitude,
              position.coords.longitude
            );
            this.loadingDetectLocation = false;
            this.pinningError=false;
          },
          () => {
            this.pinningError = true;
            this.loadingDetectLocation = false;
          }
        );
      } else {
        this.pinningError = true;
      }
    },
    handleNoGeolocation() {
      this.pinningError = true;
      //add Marker on branch location or midtown
      this.selectedTrip.restaurantStop &&
      this.selectedTrip.restaurantStop.location
        ? this.setMapMarker(
            this.selectedTrip.restaurantStop.location.lat,
            this.selectedTrip.restaurantStop.location.lon
          )
        : this.setMapMarker(egypt.lat, egypt.lon);

      //get pool polygon not used for now for permission reasons
      /* axios({
         method: "GET",
        url:`https://fdm-test.elmenus.com/api/fleet-svc/1.0/lookup/pool/${this.selectedTrip.poolUuid}/polygon`,
        headers:headers
      }
        ).then(res=>{
                  let bounds = new google.maps.LatLngBounds();
                  for (let i = 0; i < res.data.polygonCoords.length; i++) {
                  bounds.extend(this.polygonCoords[i]);
                   }
                  this.setMapMarker(bounds.getCenter().lat(),bounds.getCenter().lng())
       
        })
        .catch(err=>{
        console.log(err);
        this.setMapMarker(egypt.lat,egypt.lon)});*/
    },
    setMapMarker(lat, lng) {
      var pos = new google.maps.LatLng(lat, lng);
      if(userLocationMarker){
userLocationMarker.setPosition(pos);
      }
      else{
      userLocationMarker = new google.maps.Marker({
        position: pos,
        map: locationMap,
        icon: {
          url: "/public/img/map-marker.png",
          scaledSize: new window.google.maps.Size(21, 41),
        },
        title: "Here you are",
        draggable: true,
      });
      google.maps.event.addListener(userLocationMarker, 'drag', ()=>this.pinningError=false);
      }
      locationMap.setCenter(pos);
    },
    
    submitLocation() {
      console.log(
        userLocationMarker.position.lat(),
        userLocationMarker.position.lng()
      );
      let newHeaders = Object.assign(headers);
      newHeaders["Accept"] = "text/plain";
      axios({
        method: "PUT",
        url: servicesURL.addUserLocationOnTrip(this.selectedTrip.uuid),
        headers: newHeaders,
        data: JSON.stringify({
          lon: userLocationMarker.position.lng(),
          lat: userLocationMarker.position.lat(),
        }),
      })
        .then((res) => {
          this.$root.selectedTrip.customerStop.location = {
            ...this.$root.selectedTrip.customerStop.location,
            lon: userLocationMarker.position.lng(),
            lat: userLocationMarker.position.lat(),
          };

          this.openTracking();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openTracking() {
      this.$emit("showTracking", true);
    },
  },
});
